import http from './httpService';

const apiEndPoint = '/card-codes';

function cardCodeUrl(id) {
  return `${apiEndPoint}/${id}`;
}

export function getCardCodes() {
  return http.get(apiEndPoint);
}

export function getCardCode(cardCodeId) {
  return http.get(cardCodeUrl(cardCodeId));
}

export function saveCardCode(cardCode) {
  if (cardCode._id) {
    const body = { ...cardCode };
    delete body._id;
    return http.put(cardCodeUrl(cardCode._id), body);
  }

  return http.post(apiEndPoint, cardCode);
}

export function deleteCardCode(cardCodeId) {
  return http.delete(cardCodeUrl(cardCodeId));
}
